/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FeatureFlagName {
    TIK_TOK_RESEARCH_FEATURE = 'TIK_TOK_RESEARCH_FEATURE',
    PREMIUM_AI_TRANSLATION_MODEL_FEATURE_FLAG = 'PREMIUM_AI_TRANSLATION_MODEL_FEATURE_FLAG',
    NON_PROXIED_MEDIA_UPLOAD = 'NON_PROXIED_MEDIA_UPLOAD',
    INTERCOM_ARTICLES = 'INTERCOM_ARTICLES',
    CLONING_MEDIA = 'CLONING_MEDIA',
    REASSIGN_SALES = 'REASSIGN_SALES',
    SESSION_REPLAY = 'SESSION_REPLAY',
    SESSION_REPLAY_FOR_TRIALS = 'SESSION_REPLAY_FOR_TRIALS',
    USER_FLOW = 'USER_FLOW',
    TRANSACTION_MATCHING_JOBS = 'TRANSACTION_MATCHING_JOBS',
    TASKS_PAGE = 'TASKS_PAGE',
    INBOX_SPLITTER_FEATURE = 'INBOX_SPLITTER_FEATURE',
    ONBOARDING = 'ONBOARDING',
    NEW_AI_TRANSLATION_FLOW = 'NEW_AI_TRANSLATION_FLOW',
    AI_CHATTING_FEATURE = 'AI_CHATTING_FEATURE',
    ONGOING_CAMPAIGN_FEATURE = 'ONGOING_CAMPAIGN_FEATURE',
}
